import { Divider, RectangleSkeleton } from '@treezor/design-system';

export function KycDocumentListLoader() {
  const rows = new Array(10).fill(undefined).map((_) => ({}));

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-start gap-3 my-2">
        <RectangleSkeleton width={80} height={16} margin="0" />
        <RectangleSkeleton width={120} height={16} margin="0" />
      </div>

      <div className="flex flex-col gap-3.5 py-3.5 px-3.5 border-2 border-primary rounded-200 bg-primary w-full">
        {rows.map((_, index) => (
          <div className="flex flex-col gap-4" key={`loader-item-${index}`}>
            <div className="flex flex-col gap-2">
              <RectangleSkeleton height={14} width={100} margin="0" />
              <RectangleSkeleton height={10} width={160} margin="0" />
            </div>
            {index !== rows.length - 1 && <Divider />}
          </div>
        ))}
      </div>
    </div>
  );
}
